import { render, staticRenderFns } from "./greetingsView.vue?vue&type=template&id=5e5b83ab&scoped=true&"
import script from "./greetingsView.vue?vue&type=script&lang=js&"
export * from "./greetingsView.vue?vue&type=script&lang=js&"
import style0 from "./greetingsView.vue?vue&type=style&index=0&id=5e5b83ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b83ab",
  null
  
)

export default component.exports